import { Link } from "react-router-dom";

export default function ArticleGuideSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-2">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight">
            Spreadsheet Guides
          </h2>
          <p className="text-sm text-foreground-500">Learn to shop smarter</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <Link
            to="/itaobuyspreadsheet-guide"
            className="group md:col-span-1 bg-background-100 rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimal%20educational%20visual%20with%20spreadsheet%20icon%20on%20a%20warm%20cream%20background%2C%20fresh%20modern%20design%2C%20soft%20natural%20light%2C%20approachable%20and%20friendly%20aesthetic%2C%20no%20harsh%20shadows&width=600&height=400&seq=guide-what-v9&orientation=landscape"
              alt="What is ItaobuySpreadsheet - Complete Guide"
              title="What is ItaobuySpreadsheet? Complete Beginner Guide"
              className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                What is ItaobuySpreadsheet?
              </h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                A complete beginner guide explaining how this shopping spreadsheet system works and why it is trending among online shoppers worldwide.
              </p>
              <span className="inline-block mt-4 text-sm font-medium text-primary-600 group-hover:underline">
                Read Full Guide →
              </span>
            </div>
          </Link>

          <div className="md:col-span-1 flex flex-col gap-6">
            <Link
              to="/itaobuyspreadsheet-how-to-use"
              className="group bg-background-100 rounded-2xl p-6 flex-1 cursor-pointer"
            >
              <h3 className="text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                How to Use the Spreadsheet
              </h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Step-by-step walkthrough covering product search, filtering, and maximizing your savings with ItaobuySpreadsheet tools.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20visual%20on%20clean%20warm%20pastel%20background%2C%20organized%20layout%20with%20numbered%20elements%2C%20minimal%20design%2C%20friendly%20and%20approachable%20style%2C%20soft%20lighting&width=600&height=400&seq=guide-how-v9&orientation=landscape"
                alt="How to Use ItaobuySpreadsheet"
                title="How to Use ItaobuySpreadsheet Guide"
                className="w-full h-32 object-cover rounded-xl mt-4"
                loading="lazy"
              />
              <span className="inline-block mt-3 text-sm font-medium text-primary-600 group-hover:underline">
                Read Tutorial →
              </span>
            </Link>
            <Link
              to="/itaobuyspreadsheet-safety-guide"
              className="group bg-secondary-100 rounded-2xl p-6 flex-1 cursor-pointer"
            >
              <h3 className="text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">Safety and Tips</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Important safety guidelines and expert tips for using spreadsheet-based shopping platforms responsibly and effectively.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20safety%20and%20trust%20visual%20on%20a%20soft%20warm%20cream%20background%2C%20shield%20or%20protection%20concept%20with%20clean%20modern%20design%2C%20professional%20yet%20friendly%20mood%2C%20soft%20natural%20lighting&width=600&height=400&seq=guide-safety-v9&orientation=landscape"
                alt="Safety Tips for ItaobuySpreadsheet"
                title="ItaobuySpreadsheet Safety Guide"
                className="w-full h-32 object-cover rounded-xl mt-4"
                loading="lazy"
              />
              <span className="inline-block mt-3 text-sm font-medium text-primary-600 group-hover:underline">
                Read Safety Guide →
              </span>
            </Link>
          </div>

          <div className="md:col-span-1 bg-background-100 rounded-2xl p-6 flex flex-col justify-between">
            <div>
              <h3 className="text-lg font-semibold text-foreground-950">Why Trust ItaobuySpreadsheet?</h3>
              <ul className="mt-4 space-y-3">
                <li className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>Used by thousands of online shoppers worldwide</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>Frequently updated with fresh, accurate data</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>Transparent product comparison structure</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>Beginner-friendly ecosystem with clear guides</span>
                </li>
              </ul>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer self-start"
            >
              Start Using ItaobuySpreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}